import { Route, Routes } from 'react-router-dom'
import EditForm from './SubscriptionForm/EditForm'
import CreateForm from '@/containers/SubscriptionFormPageNew/SubscriptionForm/CreateForm'
import ContactSearchPage from '@/containers/ContactSearchPage/ContactSearchPage'

const SubscriptionForm = () => {
  return (
    <Routes>
      <Route path='/add' exact element={<CreateForm />} />
      <Route path='/search' exact element={<ContactSearchPage />} />
      <Route path='/:id' element={<EditForm />} />
    </Routes>
  )
}

export default SubscriptionForm
